import { Platform } from "@angular/cdk/platform";
import { Injectable } from "@angular/core";
import jspdf from 'jspdf';
import 'jspdf-autotable';


@Injectable({
  providedIn: 'root' 
})
export class PDFService {
    head = [['ID', 'Country', 'Rank', 'Capital']]

    data = [
        [1, 'Finland', 7.632, 'Helsinki'],
        [2, 'Norway', 7.594, 'Oslo'],
        [3, 'Denmark', 7.555, 'Copenhagen'],
        [4, 'Iceland', 7.495, 'Reykjavík'],
        [5, 'Switzerland', 7.487, 'Bern'],
        [9, 'Sweden', 7.314, 'Stockholm'],
        [73, 'Belarus', 5.483, 'Minsk'],
    ]
    constructor(public platform: Platform) {

    }
    generatePdf() {
        var bodyData = [];

        var docDefinition = {
            pageMargins: [40, 80, 40, 60],

            header: [
                {
                    layout: 'noBorders',
                    style: 'headerTable',
                    table: {
                        width: '90%',
                        widths: ['auto', '*', 'auto'],
                        body: [
                            [
                                { text: '' },
                                { text: '' },
                                { text: 'BILL OF LADING', style: 'textBillOfLading', margin: [0, 0, 20, 0] }
                            ],
                            [
                                { image: 'logoImage', style: 'imgLogo', fit: [180, 180], margin: [20, 0, 0, 0] },
                                { text: '' },
                                { text: '' },
                            ],
                        ]
                    }
                },
            ],
            footer: [
                {
                    columns: [
                        {
                            width: '50%',
                            text: '',
                        },
                        {
                            width: '50%',
                            text: '',
                        },
                    ]
                },
                {
                    columns: [
                        {
                            width: '*',
                            text: 'Thank you for your business!',
                            style: 'textThankYou'
                        },
                    ]
                }
            ],
            content: [
                {
                    width: '40%',
                    text: 'SHIPMENT #: ',
                    style: 'textShipmentNo'
                },
                {
                    width: '40%',
                    text: 'SHIPMENT Date: ',
                    style: 'textShipmentDate'
                },
                {
                    width: '40%',
                    text: 'Printed Date/Time: ',
                    style: 'textPrintedDateTime'
                },
                {
                    width: '40%',
                    text: `Entered by:`,
                    style: 'textPrintedDateTime'
                },
                {
                    width: '50%',
                    text: 'TO',
                    style: 'textTo'
                },
                {
                    width: '50%',
                    text: 'ticketCustomer.name',
                    style: 'txtCustomerName'
                },
                {
                    width: '50%',
                    text: 'ticketCustomer.addressline1 + (ticketCustomer.addressline2 ? ',
                    style: 'textAddress'
                },
                {
                    width: '50%',
                    text: 'ticketCustomer.city',
                    style: 'textCityStateZip'
                },
                {
                    style: 'itemsTable',
                    table: {
                        headerRows: 2,
                        widths: [70, 90, 45, 30, 75, 90, 70],
                        body: this.updateItemsTable(bodyData, undefined),
                        pageBreak: 'after'
                    },
                },
                { text: 'Customer Signature:', style: 'customerSign', margin: [10, 0, 0, 0] },
                { image: 'ticketSignature', style: 'ticketSign', fit: [150, 150], margin: [10, 0, 0, 0] },
            ],
            styles: {
                headerTable: {
                    border: 'none',
                    margin: [0, 10, 0, 0],
                },
                imgLogo: {
                    left: '10%',
                },
                textBillOfLading: {
                    bold: true,
                    fontSize: 22,
                    alignment: 'right',
                },
                textShipmentNo: {
                    bold: true,
                    fontSize: 12,
                    alignment: 'right',
                    margin: [0, 10, 0, 0],
                },
                textShipmentDate: {
                    bold: true,
                    fontSize: 12,
                    alignment: 'right'
                },
                textPrintedDateTime: {
                    fontSize: 10,
                    alignment: 'right'
                },
                textTo: {
                    bold: true,
                    fontSize: 12,
                },
                txtCustomerName: {
                    bold: true,
                    fontSize: 12,
                },
                textAddress: {
                    bold: true,
                    fontSize: 12,
                },
                textCityStateZip: {
                    bold: true,
                    fontSize: 12,
                    margin: [0, 0, 0, 30]
                },
                txtSplitWith: {
                    bold: true,
                    fontSize: 12,
                },
                itemRow: {
                    fontSize: 10,
                },
                itemsTable: {
                    margin: [0, 0, 0, 15],
                    width: '100%',
                },
                tableHeader: {
                    bold: true,
                    fontSize: 13,
                    color: 'black',
                    width: '100%',
                },
                tableHeaderQuantity: {
                    bold: true,
                    fontSize: 13,
                    color: 'black',
                    width: '100%',
                    alignment: 'right',
                },
                tableHeaderUOM: {
                    bold: true,
                    fontSize: 13,
                    color: 'black',
                    width: '100%',
                    alignment: 'center',
                },
                textThankYou: {
                    bold: true,
                    fontSize: 20,
                    color: 'black',
                    width: '100%',
                    alignment: 'center',
                },
                ticketSign: {
                    alignment: 'left',
                },
                customerSign: {
                    width: '100%',
                    fontSize: 15,
                    bold: true,
                    alignment: 'left',
                }
            }
        }

        let doc = new jspdf('p', 'mm', 'a4');
        doc.setFontSize(18);
        doc.text('My PDF Table', 11, 8);
        doc.setFontSize(11);
        doc.setTextColor(100);


        (doc as any).autoTable({
            head: this.head,
            body: this.data,
            theme: 'plain',
            didDrawCell: data => {
                console.log(data.column.index)
            }
        })

        // Open PDF document in new tab
        doc.output('dataurlnewwindow');
        doc.addPage()

        // Download PDF document  
        //doc.save('table.pdf');

        // merge(['table.pdf', 'table.pdf'], 'File Ouput.pdf', function (err) {
        //     if (err) {
        //         return console.log(err)
        //     }
        //     console.log('Successfully merged!')
        // });

    }
    // async mergePdfs(pdfsToMerges: ArrayBuffer[]) {
    //     const mergedPdf = await PDFDocument.create();
    //     const actions = pdfsToMerges.map(async pdfBuffer => {
    //         const pdf = await PDFDocument.load(pdfBuffer);
    //         const copiedPages = await mergedPdf.copyPages(pdf, pdf.getPageIndices());
    //         copiedPages.forEach((page) => {
    //             // console.log('page', page.getWidth(), page.getHeight());
    //             // page.setWidth(210);
    //             mergedPdf.addPage(page);
    //         });
    //     });
    //     await Promise.all(actions);
    //     const mergedPdfFile = await mergedPdf.save();
    //     return mergedPdfFile;
    // }
    updateItemsTable(data, ticketCustomerSplit?: any) {
        try {
            var body = [];
            var columnHeader1 = [], columnHeader2 = [];
            var splitWith = '';

            if (ticketCustomerSplit) {
                splitWith = ticketCustomerSplit.SplitDescription;
            } else {
                splitWith = '';
            }

            columnHeader1.push({ text: 'Split With: ' + splitWith, style: 'tableHeader', colSpan: 7 }, {}, {}, {}, {}, {}, {});
            columnHeader2.push({ text: 'ITEMS', style: 'tableHeader' });
            columnHeader2.push({ text: 'DESCRIPTION', style: 'tableHeader' });
            columnHeader2.push({ text: 'QTY', style: 'tableHeaderQuantity' });
            columnHeader2.push({ text: 'UOM', style: 'tableHeaderUOM' });
            columnHeader2.push({ text: 'CONTAINER', style: 'tableHeader' });
            columnHeader2.push({ text: 'COMMENTS', style: 'tableHeader' });
            columnHeader2.push({ text: 'LICENSE', style: 'tableHeader' });


            body.push(columnHeader1);
            body.push(columnHeader2);
            var previousbillitems = data.map((item) => {
                return [
                    { text: item[0], style: 'itemRow' },
                    { text: item[1], style: 'itemRow' },
                    { text: item[2], alignment: 'right', style: 'itemRow' },
                    { text: item[3], alignment: 'center', style: 'itemRow' },
                    { text: item[4] || '', style: 'itemRow' },
                    { text: item[5] || '', style: 'itemRow' },
                    { text: item[6] || '', style: 'itemRow' },

                ];
            });

            body = body.concat(previousbillitems);
        } catch (e) {
            // this.events.publish("event:LogMessage", e, "updateItemsTable:Error");
        }
        return body;
    }
}